import styled from 'styled-components';
import { CardHeader } from 'components';

export const Page = styled.main.attrs({
  className:
    'min-h-screen w-full flex flex-col items-center justify-center bg-background gap-10 px-3 py-14',
})``;

export const Container = styled.div.attrs({
  className: 'w-full max-w-[568px] flex flex-col items-center gap-8',
})``;

export const Logo = styled.img.attrs({
  className: 'h-10 w-[214px] shrink-0',
})``;

export const CardWrapper = styled.div.attrs({
  className: 'w-full max-w-[400px]',
})``;

export const CardCustomHeader = styled(CardHeader).attrs({
  className: 'text-center gap-2 px-6 pt-6 pb-0',
})``;

export const FieldsForm = styled.form.attrs({
  className: 'space-y-4',
})``;

export const InputContainer = styled.div.attrs({
  className: 'relative',
})``;

export const LoginButtonsWrapper = styled.div.attrs({
  className: 'flex flex-col gap-2 w-full px-6 pb-6 pt-2',
})``;
